import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { logger } from "../lib/logger";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errParam = params.get("error");

    if (errParam) {
      setError("Acceso denegado en Google. Por favor intenta de nuevo.");
      setTimeout(() => navigate("/login"), 2500);
      return;
    }
    if (!code) {
      navigate("/login");
      return;
    }

    // Guard against re-processing the same code across remounts (SW activation,
    // hot-reload, accidental re-renders). Google codes are single-use; redeeming
    // twice yields "invalid_grant: Malformed auth code".
    const processedKey = "oauth_processed_" + code.slice(0, 32);
    if (sessionStorage.getItem(processedKey)) {
      navigate("/login");
      return;
    }
    sessionStorage.setItem(processedKey, "1");

    // Clear the code from the URL BEFORE any async work, so a remount cannot
    // re-extract and re-exchange a code that was already redeemed.
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const redirect_uri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google/exchange", { code, redirect_uri });
        if (data.user) {
          setUser(data.user);
        }
        const role = data.user?.role;
        if (role === "cliente") {
          navigate("/mi-billetera", { replace: true, state: { user: data.user } });
        } else if (role === "pending") {
          navigate("/pending", { replace: true, state: { user: data.user } });
        } else {
          navigate("/dashboard", { replace: true, state: { user: data.user } });
        }
      } catch (err) {
        logger.error("Google auth exchange failed", err);
        setError(err?.response?.data?.detail || "No se pudo completar el login.");
        setTimeout(() => navigate("/login"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-sm px-6">
        <div className="w-12 h-12 border-2 border-turquoise border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 font-mono text-sm">Autenticando con Google...</p>
        {error && <p className="text-red-400 text-xs mt-4 font-mono">{error}</p>}
      </div>
    </div>
  );
}
